import { Box, Paper, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

function Loading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <Paper
        elevation={0}
        sx={{
          px: 4,
          py: 5,
          textAlign: "center",
          minWidth: 280,
          borderRadius: 4,
        }}
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          データ取得中...
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          必要な情報を読み込んでいます。
        </Typography>
      </Paper>
    </Box>
  );
}

export default Loading;
